import { SocioeconomicDemographic } from './socioeconomicDemographic';
export default SocioeconomicDemographic;
